import { Outlet } from "@tanstack/react-router";

import { AppSidebar } from "@/components/AppSidebar";
import { AuthGate } from "@/components/common/AuthGate";
import { NavPerfTracker } from "@/components/common/NavPerfTracker";
import { ChatHistoryProvider } from "@/contexts/ChatHistoryContext";
import { SidebarProvider } from "@/contexts/SidebarContext";

export function AuthenticatedLayout() {
  return (
    <AuthGate>
      <ChatHistoryProvider>
        <SidebarProvider>
          <NavPerfTracker />
          <div className="flex min-h-screen bg-background text-foreground">
            <AppSidebar />
            <main className="min-w-0 flex-1">
              <Outlet />
            </main>
          </div>
        </SidebarProvider>
      </ChatHistoryProvider>
    </AuthGate>
  );
}
